import i18n from '../i18n'

export default {
    methods: {
        langChange(lang) {
            // this.langChangeState(lang)
            i18n.locale = lang.value
            // document.getElementsByClassName('iq-show')[0].classList.remove('iq-show')
            // if (lang.value === 'ar') {
            //   this.rtlAdd(lang)
            // } else {
            //   this.rtlRemove(lang)
            // }
        }
    }
}
